import { User } from 'models/user';
import { TFunction } from 'shared/i18n';

import routes from '../../../constants/routes';

type AccountInfoValues = {
  label: TFunction;
  value: string;
  href?: string;
};

type AccountInfo = {
  name?: AccountInfoValues;
  dateOfBirth?: AccountInfoValues;
  email?: AccountInfoValues;
};

const normalizeAccountInfoForFrontend = (
  t: TFunction,
  useAllowUpdateEmailAddress: boolean,
  accountInfo?: User
): AccountInfo => {
  if (!accountInfo) {
    return {} as AccountInfo;
  }

  const { firstName, lastName, dateOfBirth, email } = accountInfo;
  let normalizedAccountInfo = {} as AccountInfo;

  if (firstName && lastName) {
    normalizedAccountInfo = {
      ...normalizedAccountInfo,
      name: {
        value: `${firstName} ${lastName}`,
        label: t('personalInfo.name.label', 'Name'),
      },
    };
  }

  if (dateOfBirth) {
    normalizedAccountInfo = {
      ...normalizedAccountInfo,
      dateOfBirth: {
        value: dateOfBirth,
        label: t('personalInfo.dob.label', 'Date of birth'),
      },
    };
  }

  if (email) {
    normalizedAccountInfo = {
      ...normalizedAccountInfo,
      email: {
        value: email,
        label: t('personalInfo.email.label', 'Email'),
        ...(useAllowUpdateEmailAddress
          ? { href: routes.me.updateEmail.start.path }
          : {}),
      },
    };
  }

  return normalizedAccountInfo;
};

export default normalizeAccountInfoForFrontend;
